import { ConfirmationService } from 'primeng/api';
import { Component, OnInit, ViewChildren, QueryList, ViewChild, Input } from '@angular/core';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { Table } from 'primeng/table';
import { TabPanelHandler } from '@core/_utils/table.utils';
import { CommonService } from '@service/common.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { getField, getUserName } from '@core/_utils/tools.utils';
import { forkJoin, lastValueFrom, map } from 'rxjs';

@Component({
    selector: 'app-list-groups',
    templateUrl: './list-groups.component.html',
    styleUrls: ['./list-groups.component.scss'],
})
export class ListGroupsComponent extends TabPanelHandler implements OnInit {
    public value = true;
    public itemConfirm: ItemConfirmComponent;
    public dataList = [];
    public userList = [];
    public userListBase = [];

    protected _isInRangeTimeout: any;

    public listColumns = [];

    @ViewChildren('p-tabPanel:not(:first-child)')
    public itemChildren: QueryList<any>;

    @ViewChild('dt')
    public dataTable: Table;
    public blockEvent = false;

    @Input()
    public entities: Array<any> = [];

    public duplicate = false;

    constructor(
        private api: ApiV6Service,
        public menu: MenuServiceInt,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        protected translate: TranslateService
    ) {
        super(translate);
        this.menu.display = true;
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.listColumns = [
            { header: this.translate.instant('Cf_Wiz'), field: 'gr_autogenerated' },
            { header: this.translate.instant('Cf_GrpName'), field: 'name' },
            { header: this.translate.instant('Label'), field: 'gr_label' },            
            { header: this.translate.instant('Cf_Desc'), field: 'desc' },
        ];
        this.findAll();
        this.commonService.checkReset();
    }

    setFilteredList(event) {}

    private async findAll() {
        this.dataList = [];
        this.userListBase = [];
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.readGroupsData());
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        this.dataList = wRes.data.getGroupList.GroupList.map((item, index) => {
            item.name = item.gr_name;
            item.label = item.gr_name;
            item._label = item.gr_name;
            item.gr_label = getField(item.gr_label);
            item.desc = getField(item.gr_description);
            item.id = index + 1;
            return item;
        });
        this.getUserList(wRes.data.getUserList.UserList);
    }

    private readGroupsData() {
        return forkJoin([
            this.api.execUrlAction('getuserlistgroup', ''),
            this.api.execUrlAction('getallgrouplist', ''),]).pipe(
            map(([getUserList, getGroupList,]) => {
                return { getUserList, getGroupList };
            })
        );
    }

    private getUserList(aData) {
        let wName = '';
        this.userListBase = [];
        aData.forEach(item => {
            wName = getUserName(item, 'us_firstname', 'us_lastname', 'us_login');
            this.userListBase.push({
                label: wName,
                value: item.us_login,
            });
        })
    }

    closeTab(event) {
        this.closeTabsheet(event);
        this.index = event.index - 1;
        this.execClose(event);
    }

    validateTab(event) {
        if (event.duplicate === true) {
            this.addToDataList(event);
        } else {
            this.dataList = this.dataList.map((item, index) => {
                if (item.gr_name === event.data.data.grpname) {
                    item.desc = event.data.data.desc;
                    item.gr_autogenerated = + event.data.data.autogenerated;
                    item.gr_external = event.data.data.external;
                    item.label = event.data.data.grpname;
                    item.gr_label = event.data.data.gr_label;
                    item._label = event.data.data.grpname;
                    return item;
                } else {
                    return item;
                }
            });
        }
        this.closeTab(event);
    }

    addTab(event) {
        this.addToDataList(event);
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    private addToDataList(event) {
        this.dataList.push({
            desc: event.data.data.desc,
            gr_autogenerated: + event.data.data.autogenerated,
            gr_external: event.data.data.external,
            gr_name: event.data.data.grpname,
            label: event.data.data.grpname,
            gr_label: event.data.data.gr_label,
            name: event.data.data.grpname            
        })
        this.dataList = this.dataList.map((item, index) => {
            item._label = item.name;
            item.id = index + 1;
            return item;
        });        
    }

    deleteTab(event) {
        this.dataList = this.dataList.filter((item) => {
            return item.name !== event.data.grpname;
        });
        this.dataList = [...this.dataList];
        this.closeTab(event);
    }

    cancelAdd(event) {
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    handleChange($event) {
        this.index = $event.index;
    }

    confirmDelete(event) {
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_DelG', {label: event.data.grpname}),
            () => {
                this.delete(event);
            }
        );
    }
    
    public async delete(event) {
        let wRes: any;
        const wdata = { group: event.data.grpname };
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('deletegroup', wdata ));
            this.deleteTab(event);
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
    }

    showDetails(item) {
        item = item.data;
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.name);
        }
    }

    public clickcolDup(event, aData) {
        if (!this.isAlreadySelected(aData.id)) {
            this.duplicate = true;
        }
    }

    public onLoadItem(event) {
        this.duplicate = false;
    }

    sortReference(event: any): void {}
}
